import createCache from '@emotion/cache';

global.__webpack_nonce__ = window.csp_nonce;

export const myCache = createCache({
  key: 'my-prefix-key',
  nonce: window.csp_nonce,
});
